/**
 * Kloutforce App Routes
 * Creator-side route definitions matching Koordinator pattern.
 */
import { CANONICAL_PUBLIC_ROUTE_REGISTRY } from '@bright-web-skeleton/shared/routing';

export const routes = {
  landing: "/",
  auth: "/auth",
  authCallback: "/auth/callback",
  onboarding: "/onboarding",
  brandStore: CANONICAL_PUBLIC_ROUTE_REGISTRY.brandStore.pattern,
  brandChildStore: CANONICAL_PUBLIC_ROUTE_REGISTRY.brandChildStore.pattern,
  creatorHandle: CANONICAL_PUBLIC_ROUTE_REGISTRY.katalag.pattern,
  
  // Main app routes (creator-side)
  app: {
    home: "/home",
    discover: "/discover",
    creators: "/creators",
    create: "/create",
    notifications: "/notifications",
    dashboard: "/dashboard",
    katalog: "/katalog",
    invite: "/invite",
    instructions: "/instructions",
    dealDetail: "/deals/:id",
    agentApply: "/agent/apply",
    creatorInvite: "/creator/invite/:code",
  },
  
  // Account section
  account: {
    profile: "/account/profile",
    socials: "/account/socials",
    portfolio: "/account/portfolio",
    earnings: "/account/earnings",
    wallet: "/account/wallet",
    settings: "/account/settings",
    performance: "/account/performance",
    deals: "/account/deals",
    katalog: "/account/katalog",
    katalogs: "/account/katalogs",
    /** @deprecated Legacy singular path — redirects to /account/katalogs/:id/manage. Kept for back-compat. */
    katalogEditor: "/account/katalog/:katalogId",
    katalogsCreate: "/account/katalogs/create",
    katalogsDashboard: "/account/katalogs/:id/dashboard",
    katalogsManage: "/account/katalogs/:id/manage",
    katalogsEdit: "/account/katalogs/:katalogId/edit",
    /** Canonical public Profile route (global member). */
    profilePublic: CANONICAL_PUBLIC_ROUTE_REGISTRY.profile.pattern,
    professionalRoles: "/account/professional-roles",
    invited: "/account/invited",
    invites: "/account/invites",
  },

  // General Agent section
  generalAgent: {
    landing: "/general-agent",
    request: "/general-agent/request",
    invite: "/general-agent/invite/:code",
    welcome: "/general-agent/welcome",
    dashboard: "/general-agent/dashboard",
    earnings: "/general-agent/earnings",
    recruits: "/general-agent/recruits",
    payouts: "/general-agent/payouts",
    inviteTools: "/general-agent/invite-tools",
    instructions: "/general-agent/instructions",
    activationReturn: "/general-agent/activation-return",
    manage: "/general-agent/manage",
  },

  // Agent dashboard section
  agent: {
    landing: "/agent",
    apply: "/agent/apply",
    invite: "/agent/invite/:code",
    welcome: "/agent/welcome",
    dashboard: "/agent/dashboard",
    overview: "/agent/overview", // legacy alias → redirects to /agent/dashboard
    network: "/agent/network",
    recruits: "/agent/recruits",
    earnings: "/agent/earnings",
    payouts: "/agent/payouts",
    inviteTools: "/agent/invite-tools",
    instructions: "/agent/instructions",
    activationReturn: "/agent/activation-return",
    manage: "/agent/manage",
  },

  // Partner section
  partner: {
    landing: "/partner",
    onboarding: "/partner/onboarding",
    upgrade: "/partner/upgrade",
    invite: "/partner/invite/:code",
    welcome: "/partner/welcome",
    dashboard: "/partner/dashboard",
    earnings: "/partner/earnings",
    network: "/partner/network",
    recruits: "/partner/recruits",
    payouts: "/partner/payouts",
    inviteTools: "/partner/invite-tools",
    instructions: "/partner/instructions",
    activationReturn: "/partner/activation-return",
    manage: "/partner/manage",
  },

  // Connector section
  connector: {
    landing: "/connector",
    onboarding: "/connector/onboarding",
    invite: "/connector/invite/:code",
    welcome: "/connector/welcome",
    dashboard: "/connector/dashboard",
    earnings: "/connector/earnings",
    recruits: "/connector/recruits",
    payouts: "/connector/payouts",
    manage: "/connector/manage",
  },
} as const;
